import debug from 'bows';

const log = debug('tooltip');

export default class {
	constructor(opts) {
		this.opts = Object.assign( {
			node        : document.body,
			class       : 'tooltip',
			parentNode  : document.body,
			duration    : 1500,
			fadeDuration: 800,
		}, opts );

		if ( ! this.opts.text ) {
			return;
		}

		this.opts.class = this.opts.class.trim();

		// create our tooltip node
		this.tip = document.createElement('span');
		this.tip.className = this.opts.class;
		this.tip.appendChild( document.createTextNode( this.opts.text ) );

		// the arrow on top/bottom
		this.arrow = document.createElement('span');
		this.arrow.className = `${this.opts.class}__arrow`;
		this.tip.appendChild(this.arrow);

		this.show();

		// static listener so we can remove it
		this._remove = () => {
			this.tip.removeEventListener('transitionend', this._remove);
			this.tip.parentNode.removeChild(this.tip);
		}

		log(this);
	}

	position() {
		// measure the target node
		const rect = this.opts.node.getBoundingClientRect();

		// add the fixed top position + the document scroll
		let top = rect.top + document.documentElement.scrollTop - this.tip.offsetHeight;

		// add the fixed left position plus
		let left = rect.left + (rect.width / 2) + document.documentElement.scrollLeft - (this.tip.offsetWidth / 2);

		this.tip.style.position = 'absolute';
		this.tip.style.top = `${top}px`;
		this.tip.style.left = `${left}px`;

		let tipRect = this.tip.getBoundingClientRect();
		let gutter = 5;

		// if our tooltip if above the viewport, flip it down
		if (tipRect.top < 1) {
			this.tip.classList.add(`${this.opts.class}--below`);
			this.tip.style.top = `${top + this.opts.node.offsetHeight + tipRect.height }px`
			log('tooltip below');
		}

		if ( left < 0 ) {
			this.tip.classList.add(`${this.opts.class}--offleft`);
			this.tip.style.left = `${0 + gutter}px`;
			this.arrow.style.left = `${Math.abs(left) - gutter}px`;
			log('tooltip offleft', tipRect);
		} else if ( left + tipRect.width > document.documentElement.clientWidth ) {
			this.tip.classList.add(`${this.opts.class}--right`);
			this.tip.style.left = 'auto';
			this.tip.style.right = `${0 + gutter}px`;
			this.arrow.style.left = 'auto';
			this.arrow.style.right = `${0 + gutter}px`;
			log('tooltip offright', tipRect);
		}
	}

	show() {
		if ( ! this.tip.parentNode ) {
			// add our tooltip to our target
			this.opts.parentNode.appendChild(this.tip);
		}

		this.position();

		if ( this.opts.duration > 0 ) {
			setTimeout( this.remove.bind(this), this.opts.duration );
		}
	}

	remove() {
		this.tip.classList.add('tooltip--removing');
		this.tip.addEventListener('transitionend', this._remove);
	}
}
